class GlobalActionsLabelCell extends UITableViewCell
{
    private titleLabel:MUILabel = null;
    private nameLabel:MUILabel = null;
    
    awakeFromHTML(){
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        //this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set title (text:string) {
        this.titleLabel.text = MIOLocalizeString(text, text);
    }

    set name (text:string) {
        this.nameLabel.text = MIOLocalizeString(text, text);
    }

    set item (item:any) {
        this.nameLabel.text = MIOLocalizeString(item.name, item.name);
    }

}